import { ArrayType, convertNumber, NumberType, ObjectType, StringType, } from '@hb/map-convert';
import { convertPoint, convertPointsString, convertPointString, } from '../../utils/transform';
/**
 * 是否返回steps字段内容
 *
 * - `>0` => `0`
 * - `0` => `1`
 */
function convertPathType(v) {
    return convertNumber(v) > 0 ? 0 : 1;
}
/**
 * 返回结果控制
 * - `0` => `base`
 * - `1` => `all`
 */
function convertExtensions(v) {
    return convertNumber(v) === 0 ? 'base' : 'all';
}
/**
 * 入参转换
 */
export var queryType = {
    origin: StringType(convertPointsString),
    destination: StringType(convertPointString),
    originId: StringType('originid'),
    destinationId: StringType('destinationid'),
    originType: StringType('origintype'),
    destinationType: StringType('destinationtype'),
    strategy: StringType(),
    wayPoints: StringType('waypoints', function (v) {
        return convertPointsString(v, ';');
    }),
    number: StringType(),
    province: StringType(),
    carType: StringType('cartype'),
    ferry: StringType(),
    /**
     * 当取值为0时，steps字段内容正常返回；
     * 当取值为1时，steps字段内容为空；
     */
    pathType: StringType('nosteps', convertPathType),
    extensions: StringType(convertExtensions),
};
var tmcsType = {
    lcode: StringType(),
    distance: StringType(),
    status: StringType(),
    polyline: StringType(),
};
var districtsType = {
    name: StringType(),
    adcode: StringType(),
};
var citiesType = {
    name: StringType(),
    citycode: StringType(),
    adcode: StringType(),
    districts: ArrayType(ObjectType(districtsType)),
};
var stepType = {
    instruction: StringType(),
    orientation: StringType(),
    road: StringType(),
    duration: NumberType(),
    distance: NumberType(),
    tolls: NumberType(),
    toll_distance: NumberType('tollDistance'),
    toll_road: StringType('tollRoad'),
    polyline: StringType(),
    action: StringType(),
    assistant_action: StringType('assistantAction'),
    tmcs: ArrayType(ObjectType(tmcsType)),
    cities: ArrayType(ObjectType(citiesType)),
};
var pathType = {
    distance: NumberType(),
    duration: NumberType(),
    strategy: StringType(),
    tolls: NumberType(),
    toll_distance: NumberType('tollDistance'),
    traffic_lights: NumberType('trafficLights'),
    restriction: NumberType(),
    steps: ArrayType(ObjectType(stepType)),
};
/**
 * 返回值转换
 */
export var dataType = {
    origin: StringType('originLoc', convertPoint),
    destination: StringType('destLoc', convertPoint),
    taxi_cost: NumberType('taxiCost'),
    paths: ArrayType(ObjectType(pathType)),
};
//# sourceMappingURL=data:application/json;base64,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